import { BreadcrumbServiceV1 } from '@volkswagen-onehub/breadcrumb-service';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import { FeatureServicesContext } from './use-feature-services';

export const AddBreadcrumb = (label: string) => {
	const navigate = useNavigate();
	let breadcrumbService: BreadcrumbServiceV1;
	const featureServices = useContext(FeatureServicesContext);
	if (featureServices && featureServices['breadcrumb-service']) {
		breadcrumbService = featureServices['breadcrumb-service'];
		breadcrumbService.set([
			{
				// When the following breadcrumb is clicked
				label,
				// then push to this history
				href: '/',
				// href: history.createHref(location),
				onClick: () => navigate('/', {}),
			},
		]);
	}
};
